<template>
  <div class="preview_frame">
    <!--头部-->
    <div class="preview_header">
      <ul class="device_list">
        <li
          class="device_item device_pc"
          :class="select_icon == 'pc' ? 'select_device_pc' : ''"
          @click="change_icon('pc')"
        >
          <i class="device_icon"></i>
        </li>
        <li
          class="device_item device_pad"
          :class="select_icon == 'pad' ? 'select_device_pad' : ''"
          @click="change_icon('pad')"
        >
          <i class="device_icon"></i>
        </li>
        <li
          class="device_item device_mobi"
          :class="select_icon == 'mb' ? 'select_device_mobi' : ''"
          @click="change_icon('mb')"
        >
          <i class="device_icon"></i>
        </li>
        <li class="device_item device_qrcode">
          <i class="device_icon"></i>
          <div class="vistor_preview_qrcode">
            <div class="vistor_preview_qrcode_img"></div>
          </div>
        </li>
      </ul>
      <div class="close_vistor_preview" @click="back">{{$t('view_preview_index_55')}}</div>
    </div>

    <!--中间预览部分-->
    <div class="preview_iframe_parent">
      <div class="preview_iframe_box" :class="'preview_iframe_' + select_icon">
        <div class="vistor_preview_header">
          <i class="vistor_preview_header_icon"></i>
        </div>
        <!-- + '?view_pattern=' + select_icon-->
        <iframe
          :src="iframeSrc"
          frameborder="0"
          class="pc_preview_iframe"
          @load="complete"
          allowfullscreen="true"
        ></iframe>
        <div class="vistor_preview_footer">
          <i class="vistor_preview_footer_icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import Cookies from "js-cookie";
import QRCode from 'qrcodejs2'

export default {
  name: "preview",
  data() {
    return {
      num: 0,
    };
  },
  methods: {
    complete() {
      $.myMongoliaClose();
    },
    change_icon(item) {
      this.$store.commit("preview/SET_select", item);
      this.num = Math.random();
    },
    back() {
      $(".preview_header").removeClass("preview_header_show");

      //可视化显示
      this.$store.commit("app/set_app_isSHow", true);

      //预览关闭
      const timer = setTimeout(() => {
        this.$store.commit("preview/SET_isShow", false);
        clearTimeout(timer);
      }, 200);

      //清理缓存
      //this.templet.clearStatic();
    },
    showQRCode() {
      console.log('this.iframeSrc:', this.iframeSrc)
      if($('.vistor_preview_qrcode_img').length > 0) {
        $('.vistor_preview_qrcode_img').empty()
      }
      new QRCode(document.querySelector('.vistor_preview_qrcode_img'), {
        text: this.iframeSrc,
        width: 128,
        height: 128,
        colorDark: "#000000",
        colorLight: "#ffffff"
      });
    }
  },
  computed: {
    iframeSrc() {
      return this.$store.state.preview.path
    },
    select_icon() {
      return this.$store.state.preview.select;
    },
    qrcode() {
      const src =
        process.env.BASE_API +
        "/admin/home/getQrcode?url=" +
        escape(this.$store.state.preview.path) +
        "&admin-token=" +
        Cookies.get("admin_token_wm");

      return src;
    },
    is_mb() {
      if (this.$store.state.preview.select == 'pc') {
        return 'false'
      } else {
        return 'true'
      }
    },
  },
  watch: {
    iframeSrc() {
      this.showQRCode()
    }
  },
  mounted() {
    // $.myMongoliaOpen($(".preview_frame")[0]);
    this.showQRCode()
    const timer = setTimeout(() => {
      $(".preview_header").addClass("preview_header_show");
      clearTimeout(timer);
    }, 50);

    //可视化显示
    this.$store.commit("app/set_app_isSHow", false);
  }
};
</script>

<style scoped lang="scss">
.preview_frame {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
  width: 100%;
  height: 100%;

  .preview_header {
    background: #fff;
    width: 100%;
    height: 60px;
    position: relative;
    z-index: 3011;
    -webkit-box-shadow: 0 3px 5px 1px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 3px 5px 1px rgba(0, 0, 0, 0.1);
    box-shadow: 0 3px 5px 1px rgba(0, 0, 0, 0.1);
    transform: translate(0, -60px);
    transition: all 0.2s;

    .close_vistor_preview {
      position: absolute;
      top: 0;
      right: 0;
      width: 120px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      background: #5874d8;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
    }

    .device_list {
      height: 100%;
      text-align: center;
      font-size: 0;

      .device_item {
        display: inline-block;
        cursor: pointer;
        line-height: 60px;

        .device_icon {
          display: inline-block;
          vertical-align: middle;
          width: 21px;
          height: 21px;
          margin: 0 15px;
          background: url(../../assets/image/mbg01.png) no-repeat;
        }

        .vistor_preview_qrcode {
          display: none;
          position: absolute;
          left: 50%;
          margin-left: 2px;
          top: 78px;
          width: 150px;
          height: 150px;
          padding: 16px;
          -webkit-border-radius: 4px;
          -moz-border-radius: 4px;
          border-radius: 4px;
          background: #fff;
          -webkit-box-shadow: rgba(0, 0, 0, 0.15) 0 0 12px;
          -moz-box-shadow: rgba(0, 0, 0, 0.15) 0 0 12px;
          box-shadow: rgba(0, 0, 0, 0.15) 0 0 12px;

          img {
            width: 100%;
          }
        }
      }

      .device_pc .device_icon {
        background-position: -290px -150px;
      }

      .device_pad .device_icon {
        background-position: -324px -150px;
      }

      .device_mobi .device_icon {
        background-position: -359px -150px;
      }

      .device_qrcode .device_icon {
        background-position: -392px -150px;
      }

      .device_pc .device_icon:hover {
        background-position: -428px -150px;
      }

      .device_pad .device_icon:hover {
        background-position: -464px -150px;
      }

      .device_mobi .device_icon:hover {
        background-position: -497px -150px;
      }

      .select_device_pc .device_icon {
        background-position: -428px -150px;
      }

      .select_device_pad .device_icon {
        background-position: -464px -150px;
      }

      .select_device_mobi .device_icon {
        background-position: -497px -150px;
      }

      .device_qrcode:hover .vistor_preview_qrcode {
        display: block;
      }

      .device_qrcode:hover .vistor_preview_qrcode.vistor_preview_qrcode:before {
        z-index: 1;
        content: "";
        display: inline-block;
        position: absolute;
        top: -4px;
        right: 50%;
        margin-right: -5px;
        width: 10px;
        height: 10px;
        background: #fff;
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }
  }

  .preview_header_show {
    transform: translate(0, 0);
  }
}

.preview_iframe_parent {
  width: 100%;
  height: calc(100% - 60px);
  position: relative;
  background: #e0e0e1;

  .preview_iframe_box {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: 0 auto;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .pc_preview_iframe {
      width: 100%;
      height: 100%;
      background: #fff;
    }

    .vistor_preview_header {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      height: 40px;
      width: 100%;
      background: #eeeff2;
      text-align: center;
      line-height: 40px;
      -webkit-border-top-right-radius: 40px;
      -moz-border-radius-topright: 40px;
      border-top-right-radius: 40px;
      -webkit-border-top-left-radius: 40px;
      -moz-border-radius-topleft: 40px;
      border-top-left-radius: 40px;

      .vistor_preview_header_icon {
        display: inline-block;
        width: 45px;
        height: 10px;
        background: #c8c9cc;
        -webkit-border-radius: 9px;
        -moz-border-radius: 9px;
        border-radius: 9px;
        vertical-align: middle;
      }
    }

    .vistor_preview_footer {
      display: none;
      position: absolute;
      bottom: 0;
      left: 0;
      height: 60px;
      width: 100%;
      background: #eeeff2;
      text-align: center;
      line-height: 60px;
      -webkit-border-bottom-right-radius: 40px;
      -moz-border-radius-bottomright: 40px;
      border-bottom-right-radius: 40px;
      -webkit-border-bottom-left-radius: 40px;
      -moz-border-radius-bottomleft: 40px;
      border-bottom-left-radius: 40px;

      .vistor_preview_footer_icon {
        display: inline-block;
        width: 32px;
        height: 32px;
        background: #c8c9cc;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        vertical-align: middle;
      }
    }
  }

  .preview_iframe_pc {
    width: 100%;
    height: 100%;
  }

  .preview_iframe_pad {
    width: 768px;
    height: -webkit-calc(100% - (44px + 60px));
    height: -moz-calc(100% - (44px + 60px));
    height: calc(100% - (44px + 60px));
    padding-top: 40px;
    padding-bottom: 60px;
    margin-top: 44px;
    -webkit-border-radius: 40px;
    -moz-border-radius: 40px;
    border-radius: 40px;

    .vistor_preview_header {
      display: block;
    }

    .vistor_preview_footer {
      display: block;
    }
  }

  preview_iframe_pad .pc_preview_iframe::-webkit-scrollbar {
    width: 0px;
  }

  .preview_iframe_mb {
    width: 375px;
    height: 667px;
    max-height: -webkit-calc(100% - (44px + 60px));
    max-height: -moz-calc(100% - (44px + 60px));
    max-height: calc(100% - (44px + 60px));
    padding-top: 40px;
    padding-bottom: 60px;
    margin-top: 44px;
    -webkit-border-radius: 40px;
    -moz-border-radius: 40px;
    border-radius: 40px;

    .vistor_preview_header {
      display: block;
    }

    .vistor_preview_footer {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/preview/index.vue